import { useState,useEffect } from "react"
import style from "./controlPanel.module.scss"
import axios from "axios"

const MenuTexts = ({ setting, setSetting }) => {
	const selectledtext = row =>{
		setSetting({
			...setting,
			ledtext:row,
		})
	}	

	const [rows, setRows] = useState([]);
	const [totPage, setTotPage] = useState(1);

	useEffect(() => {
		async function getTotalPage() {
		  const total = await axios.get(
			`${process.env.REACT_APP_PUBLIC_API_URL}/texts/page`
		  );
		  setTotPage(total.data.page);
		  await handlePage([], 1);
		}
		getTotalPage();

		setSetting({
			...setting,
			textchg : 0,
		})
	}, [setting && setting.textchg? setting.textchg:null]);	

	const handlePage = async (_, value) => {
		try {
			const resp = await axios.get(
			`${process.env.REACT_APP_PUBLIC_API_URL}/texts?page=${value}`
			);
			if(resp.data.data)setRows(resp.data.data);
			else{
			}
		}catch (err) {
			alert(err);
		}
	};	


	function StopRow({row}) {
		var str = row.html.replace(/<p>/g, '');
		var str = str.replace(/<\/p>/g, '');
		// var str = row.html.replace("<p>","<p style=\"padding:0px;\"}>")
		return (
			<div key={row.id} style={{ display: 'flex', marginTop:'7px'}}>
				<div style={{  flex: '30%'}}>	
				<button onClick={() => selectledtext(row)}>{row.textno}</button>
				<span style={{color:'#D7BA5F'}}> {row.textname}</span>
				</div>
				<div style={{  flex: '70%', marginTop:'3px'}}>	
				<span dangerouslySetInnerHTML={{__html: str}}></span>
				</div>
				{/* <button style={{marginLeft:'0px', marginRight:'-5px',color:'#D7BA5F'}} onClick={() => selectledtext(row)}>{row.desc}</button> */}
			</div>		
		);
	};			

	return <>
		<div
			className={style.controlPanelInfo}
			// style={{overflow: 'scroll'}}
		>
		{/* {objects} */}
		{rows.map((row) => (
			<StopRow key={row.id}
				row={row}
			/>
		))}
		</div>
	</>
}

export default MenuTexts
